import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import copy from 'copy-to-clipboard'
import { Field } from 'factorial-form'
import { FormikProps } from 'formik'
import { UpdateAttendanceSettingMutationVariables } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import InputText from 'modules/core/components/Inputs/Text'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { Return } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

// TODO: using a private component
import ActivateCompanySlug from 'modules/app_store/components/ActivateAddonModal/ActivateCompanySlug'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

type TouchableProps = React.ComponentProps<typeof Button>

interface Props {
  attendanceSetting: AttendanceSetting
  policyForm: FormikProps<UpdateAttendanceSettingMutationVariables>
  updatePolicy: (value: { successFlash: boolean }) => Promise<Return<void>>
}

const FaceRecognitionUrl = ({ attendanceSetting, policyForm, updatePolicy }: Props) => {
  const { company } = useCurrentSession()

  const [slugModal, setSlugModal] = React.useState<boolean>(!company.slug)

  const hasSlugAndPublicToken = (): boolean => !!company.slug && !!attendanceSetting.publicToken

  const completeURL =
    company.publicUrl?.concat(
      `/face_recognition?token=${String(attendanceSetting.publicToken)}&setting_id=${
        attendanceSetting.id
      }`
    ) ?? ''

  const copyURL: TouchableProps['onClick'] = (event) => {
    event.preventDefault()
    attendanceSetting.publicToken && copy(completeURL)
    app.setFlash({
      type: 'correct',
      message: i18n.t('time_tracking.settings.success_copy_url'),
    })
  }

  const disableFaceRecognition = () => {
    policyForm.setFieldValue('faceRecognition', false)

    updatePolicy({
      successFlash: false,
    })
  }

  const onSuccessSlug = async () => {
    setSlugModal(false)
    return true
  }

  const onCloseSlug = () => {
    setSlugModal(false)

    if (!company.slug) {
      disableFaceRecognition()
    }
  }

  return (
    <Box>
      {hasSlugAndPublicToken() && (
        <Box gap="s16">
          <InputText
            label={i18n.t('time_tracking.settings.form.toggle.face_recognition.url')}
            readonly
            field={new Field(completeURL, 'string')}
            secondaryLabel={
              <InformationTooltip
                information={i18n.t('time_tracking.settings.form.toggle.face_recognition.question')}
                icon="question"
              />
            }
          />
          <Button onClick={copyURL} type="secondary">
            {i18n.t('time_tracking.settings.form.toggle.face_recognition.copy_url')}
          </Button>
          <HelpCenterLink name="face_recognition">
            {i18n.t('time_tracking.settings.form.toggle.face_recognition.link')}
          </HelpCenterLink>
        </Box>
      )}
      {slugModal && <ActivateCompanySlug onSuccess={onSuccessSlug} onClose={onCloseSlug} />}
    </Box>
  )
}

export default observer(FaceRecognitionUrl)
